var _jsxFileName = "/codebuild/output/src3324671287/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/Providers/index.tsx";
import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import i18next from 'i18next';
import { useTheme as useThemeName } from 'Hooks';
import { registerLocales } from 'Utilities/registerLocales';
import { store } from 'Utilities/store';
const Providers = ({
  children
}) => {
  const {
    theme: themeName
  } = useThemeName();
  registerLocales();
  const defaultTheme = themeName.endsWith('Dark') ? 'dark' : 'light';
  const locale = store.getState().env.phoneLanguage;
  const dir = i18next.dir(locale);
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: locale,
    dir: dir,
    defaultTheme: defaultTheme,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, children);
};
export { Providers };